import axios from 'axios';

// API location:
// - normal cloud build (app.mmmpos.store)  -> https://api.mmmpos.store
// - local/offline install (served by the API itself on localhost:3001) -> same origin ('')
// - npm start dev server (localhost:3000)  -> still uses the cloud API
// - REACT_APP_API_URL at build time overrides everything
// REACT_APP_LOCAL_MODE=true is baked in at build time by make-usb.bat.
// This means isLocalInstall is true on ANY browser/device that loads this build
// (including other PCs on the network accessing by IP — which is correct).
const isLocalInstall =
  process.env.REACT_APP_LOCAL_MODE === 'true' ||
  (['localhost', '127.0.0.1'].includes(window.location.hostname) &&
   window.location.port !== '3000');

const baseURL =
  process.env.REACT_APP_API_URL !== undefined
    ? process.env.REACT_APP_API_URL
    : (isLocalInstall ? '' : 'https://api.mmmpos.store');

const api = axios.create({ baseURL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    const isPlatform = String(error.config?.url || '').includes('/api/platform');

    if (status === 401 && !isPlatform) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }

    // 402 = trial / subscription ended -> send them to the "expired" screen.
    if (status === 402) {
      const data = error.response?.data || {};
      // stash the message + company so the screen can show them
      localStorage.setItem('expired_info', JSON.stringify({
        message: data.error || 'Your trial or subscription has ended.',
        company_name: data.company_name || '',
        reason: data.reason || 'expired',
      }));
      if (window.location.pathname !== '/expired') window.location.href = '/expired';
    }

    return Promise.reject(error);
  }
);

// Resolve a relative upload path (e.g. /uploads/foo.jpg) to a full URL.
// Always mirrors baseURL so images load from the same origin as the API.
const DEV_API = baseURL;

export const resolveMediaUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return `${DEV_API}${url}`;
};

export { isLocalInstall };
export default api;